import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Cache } from 'aws-amplify';
import { MachineRouteService } from '../machine-route.service';
import { InventoryHttpService } from '../../../../core/inventory';
import { InventoryDialogComponent } from './inventory-dialog/inventory-dialog.component';
import { MixpanelService } from '../../../../services/mixpanel.service';

@Component({
  selector: 'kt-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent implements OnInit {

	selectedMachine: any;

	beanSize = "0px";
	public bgkColor = "red";
	public height = "20%";
	inventory = [];
	user;
	role ;
	private dialogConfig = new MatDialogConfig();

  constructor(
    private route: ActivatedRoute,
    private machineRouteService: MachineRouteService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    public http: InventoryHttpService,
    private _snackBar: MatSnackBar,
    private mixPanelService: MixpanelService
  ) {}

  ngOnInit() {
	this.selectedMachine = this.machineRouteService.getMachine(this.route);
	if (!this.selectedMachine) return;

	this.user = Cache.getItem('userAttr');
	this.role = this.user['custom:role'];

	this.getInventory();

	// for(let i=0;i<this.inventory.length;i++){
	// 	if(this.inventory[i].name == "BEANS"){
	// 		beansObj = this.inventory[i];
	// 		this.inventory.slice(i, i+1);
	// 	}
	// }

	setTimeout(() => {
		this.beanSize = "350px";
		this.cdr.detectChanges();
	}, 1000);

	this.mixPanelService.track(this.mixPanelService.PAGE_VIEW, {
		'Machine ID': this.selectedMachine.machine_id,
		'Machine Name': this.selectedMachine.machine_name,
		'Machine Serial No': this.selectedMachine.serial_no
	});
  }

  getInventory(){
	this.http.getMachineInventory({machine_id: this.selectedMachine.machine_id})
	.subscribe((invData) => {
		console.log(invData);

		if(invData.length){
			this.inventory = invData;
			let beansObj;
			if(this.inventory[this.inventory.length-1].name == "BEANS") {
				beansObj = this.inventory.pop();
				this.inventory.unshift(beansObj);
			}

			this.cdr.detectChanges();
		}
	});

  }

  calcInvLvl(obj,intent){
	let perc = 0;
	if(intent == 'inv')
		perc = (obj.remSize/obj.canSize) * 100;
	else if(intent == 'low' && (obj.lowLevel != null || obj.lowLevel != undefined))
		perc = (obj.lowLevel/obj.canSize) * 100;
	else if(intent == 'empty' && (obj.emptyLevel != null || obj.emptyLevel != undefined))
		perc = (obj.emptyLevel/obj.canSize) * 100;
	else
		perc = 0;
	return (perc).toFixed(0)+"%";
  }

  getInventoryStatus(obj): string {
	const perc = (obj.remSize / obj.canSize) * 100;
	if (perc === 0) {
		return 'empty';
	} else if (perc <= 30) {
		return 'low';
	} else {
		return 'healthy';
	}
  }

  getStatusColorClass(status: string): string {
	switch (status) {
		case 'healthy':
			return 'inventory-status-chip--healthy';
		case 'low':
			return 'inventory-status-chip--low';
		case 'empty':
			return 'inventory-status-chip--empty';
		default:
			return 'inventory-status-chip--healthy';
	}
  }

  // onEdit(obj){
	// this.dialogConfig.autoFocus = true;
	// this.dialogConfig.data = obj;
	// const dialogRef = this.dialog.open(InventoryDialogComponent, this.dialogConfig);
	// 		dialogRef.afterClosed().subscribe(res => {
	// 			if (!res) {
	// 				return;
	// 			} else {
	// 				if(obj.canSize != res.par) {
	// 					obj.canSize = res.par;
	// 				}
	// 				if((obj.lowLevel/obj.canSize) * 100 != res.low_lvl){
	// 					obj.lowLevel = (res.low_lvl/100)*obj.canSize;
	// 				}
	// 				if((obj.emptyLevel/obj.canSize) * 100 != res.empty_lvl){
	// 					obj.emptyLevel = (res.empty_lvl/100)*obj.canSize;
	// 				}
	// 				if((obj.remSize/obj.canSize) * 100 != res.rem_lvl) {
	// 					obj.remSize = (res.rem_lvl/100)*obj.canSize;
	// 				}
	// 				this.http.updateMacInv(obj)
	// 				.then(res => {
	// 					if(res.success){
	// 						this.showSnackBar("Updated Successfully", 2000);
	// 					}else{
	// 						this.showSnackBar("Unable to Update", 0);
	// 					}
	// 				})
	// 				.catch(err => {
	// 					if(err.message){
	// 						this.showSnackBar(err.message, 0);
	// 					} else {
	// 						this.showSnackBar("An error occurred. Unable to Update!!!", 0);
	// 					}
	// 				});
	// 			}
	// 		});
  // }

  // showSnackBar(message: string, duration: number) {
	// 	let snackRef = this._snackBar.open(message, 'close');
	// 	if (duration > 0) {
	// 		setTimeout(() => {
	// 			this._snackBar.dismiss();
	// 		}, duration);
	// 	}

	// 	snackRef.onAction().subscribe(() => {
	// 		this._snackBar.dismiss();
	// 	});
	// }

}
